import { generatePath } from 'react-router';
import { Dispatch } from 'redux';
import { push } from 'connected-react-router';
import { IAppState } from '../../types/state.d';
import { getTeamGuid } from '../../selectors/apiSelectors';

const pushToPage = (route: string) => (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  const state = getState();
  const teamGuid = getTeamGuid(state) as string;
  return dispatch(
    push(
      generatePath(route, {
        teamGuid,
      }),
    ),
  );
};

export default pushToPage;
